import intl from 'react-intl-universal';
import { Toggle, Typography } from '@getsynapse/design-system';
import { get, debounce } from 'lodash';
import { QuestionsProps } from '../Question';
import { useEffect } from 'react';

export const ToggleField = ({
  questionData,
  changeQuestionData,
}: QuestionsProps) => {
  const toggleValue = get(questionData, 'data.value');
  const toggleText = {
    onText: get(questionData, 'data.onText'),
    offText: get(questionData, 'data.offText'),
  };

  const updateToggleCheck = (checked: boolean) => {
    changeQuestionData('data.value', checked, questionData.id);
  };

  const changeToggleText = debounce(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      changeQuestionData(
        toggleValue ? 'data.onText' : 'data.offText',
        event.target.value,
        questionData.id
      );
    },
    500
  );

  useEffect(() => {
    if (toggleValue === '') {
      changeQuestionData('data.value', false, questionData.id);
    }
  }, [toggleValue, questionData.id, changeQuestionData]);

  return (
    <>
      <div className='flex items-center mb-2'>
        <Toggle
          id={`toggle-${questionData.id}`}
          checked={toggleValue}
          onChange={(event) => updateToggleCheck(event.target.checked)}
        />
        <input
          className='bg-transparent focus:outline-none text-sm w-full text-neutral-black leading-6 placeholder-neutral-light focus:bg-primary-lighter'
          onChange={changeToggleText}
          defaultValue={toggleValue ? toggleText.onText : toggleText.offText}
          placeholder={intl.get(
            'SETTINGS_PAGE.FORMS.DESIGN.CUSTOM_QUESTIONS.TOGGLE.VALUE'
          )}
          key={toggleValue}
        />
      </div>
      <Typography className='text-neutral-black' variant='caption'>
        {intl.get(
          'SETTINGS_PAGE.FORMS.DESIGN.CUSTOM_QUESTIONS.TOGGLE.HELP_TEXT'
        )}
      </Typography>
    </>
  );
};

export default ToggleField;
